// extracted by mini-css-extract-plugin
export default {"divModalTitle":"ImportSwydgetModal_divModalTitle__bkZlw","buttonStyle":"ImportSwydgetModal_buttonStyle__h7fj8"};